import { render, staticRenderFns } from "./PresumptiveCode.vue?vue&type=template&id=6ac68a5d&scoped=true"
import script from "./PresumptiveCode.vue?vue&type=script&lang=js"
export * from "./PresumptiveCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac68a5d",
  null
  
)

export default component.exports